import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import clsx from 'clsx';
import styles from '../Login/Login.module.css';
import { AuthPageShell } from '../Login/AuthPageShell';
import logoUrl from '../../assets/helpers/navbar/tenantpay-white.png';
import { useAuth } from '../../auth/Auth';
import { updateUserProfile } from '../../auth/_requests';
import { postLoginTask } from '../../helpers/utils/login';
import { showToast } from '../../helpers/utils/showToast';

const acquisitionSourceSchema = Yup.object().shape({
  acquisitionSource: Yup.string()
    .trim()
    .max(191, 'Maximum 191 characters')
    .required('How you heard about us is required'),
});

export function AcquisitionSource() {
  const [loading, setLoading] = useState(false);
  const { auth, saveAuth } = useAuth();
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: { acquisitionSource: '' },
    validationSchema: acquisitionSourceSchema,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        await updateUserProfile(auth!.data.token, {
          acquisitionSource: values.acquisitionSource.trim(),
        });
        await postLoginTask(auth!, navigate, saveAuth);
      } catch (error) {
        console.error('Error saving acquisition source:', error);
        showToast({
          message: 'Something went wrong. Please try again.',
          type: 'error',
        });
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <AuthPageShell variant='center'>
      <div className={styles.authFlowMax}>
        <div className={`${styles.main} ${styles.mainWide}`}>
          <div className={styles.logoWrap}>
            <img src={logoUrl} className={styles.logo} alt='logo' decoding='async' />
          </div>
          <div>
            <div className={styles.formTitle}>How did you hear about us?</div>
          </div>
          <form
            className={styles.form}
            onSubmit={formik.handleSubmit}
            noValidate
            id='kt_acquisition_source_form'
          >
            <div className={'inputWrapper'} title='How did you hear about us?'>
              <div className={'label'}>How did you hear about us?</div>
              <div
                className={clsx(
                  formik.touched.acquisitionSource && formik.errors.acquisitionSource
                    ? styles.isInvalid
                    : '',
                  formik.touched.acquisitionSource &&
                    !formik.errors.acquisitionSource &&
                    formik.values.acquisitionSource
                    ? styles.valid
                    : '',
                  'inputField'
                )}
              >
                <input
                  {...formik.getFieldProps('acquisitionSource')}
                  placeholder='Google, a friend, my landlord…'
                  type='text'
                  name='acquisitionSource'
                  autoComplete='off'
                  maxLength={191}
                  required
                  aria-required='true'
                  autoFocus
                  onKeyDown={(event) => {
                    if (event.key === 'Enter') {
                      event.preventDefault();
                      formik.handleSubmit();
                    }
                  }}
                />
              </div>
              {formik.touched.acquisitionSource && formik.errors.acquisitionSource && (
                <div className={styles.emailError}>
                  <span>{formik.errors.acquisitionSource}</span>
                </div>
              )}
            </div>
            <button
              type='submit'
              className={clsx(styles.submitBtn, loading && styles.disableBtn)}
              disabled={loading}
            >
              {!loading && <span className='indicator-label'>Next</span>}
              {loading && (
                <span
                  style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                >
                  Please wait...
                </span>
              )}
            </button>
          </form>
        </div>
      </div>
    </AuthPageShell>
  );
}
